import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { sendCodeLogin, forgetPassword } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";
import './forgetPassword.css';

class ForgetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      code: "",
      btnSend: -60,
      btnStatus: false,
      btnSec: 0,
      error: {},
      showModalSendCode: "",
      showModalBackdrop: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleCloseModalSendCode = this.handleCloseModalSendCode.bind(this);
    this.sendCodeLogin = this.sendCodeLogin.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      let btnSend = -60;
      if (this.props.errors.phone) {
        btnSend = -89;
      }
      this.setState({ error: this.props.errors, btnSend: btnSend });
    }

    if (this.props.code !== prevProps.code) {
      if (this.props.code.msg && this.props.code.msg === "Send Code OK") {
        this.setState({ showModalSendCode: "show", showModalBackdrop: "modal-backdrop show", btnStatus: true });

        let timeOutId2;
        let cnt = 0;
        timeOutId2 = setInterval(() => {
          this.setState({ btnSec: 600-cnt });
          cnt++;

          if(cnt > 600 ){
            clearInterval(timeOutId2);
            return;
          }
        }, 1000);

        let timeOutId;
        timeOutId = setTimeout(() => {
          this.setState({ btnStatus: false, btnSec: 0 });
          clearTimeout(timeOutId);
          return;
        }, 600000);
      }
    }
  };

  handleCloseModalSendCode() {
    this.setState({ showModalSendCode: "", showModalBackdrop: "" });
  }

  sendCodeLogin(e) {
    e.preventDefault();
    const { phone } = this.state;

    let error = {};
    let btnSend = -60;
    if (isEmpty(phone)) {
      error.phone= "請輸入手機號碼";
      btnSend = -89;
    } else {
      const re = new RegExp(/^[0-9]/);
      if (!re.test(phone)) {
        error.phone= "手機號碼只能輸入數字";
        btnSend = -89;
      }
    }

    if (!isEmpty(error)){
      this.setState({ error: error, btnSend: btnSend });
    } else {
      this.setState({ error: {}, btnSend: btnSend });
      this.props.sendCodeLogin({phone: phone});
    }
  }

  onClick(e) {
    e.preventDefault();
    const { phone, code } = this.state;

    let error = {};
    let btnSend = -60;
    if (isEmpty(phone)) {
      error.phone= "請輸入手機號碼";
      btnSend = -89;
    } else {
      const re = new RegExp(/^[0-9]/);
      if (!re.test(phone)) {
        error.phone= "手機號碼只能輸入數字";
        btnSend = -89;
      }
    }

    if (isEmpty(code)) {
      error.code= "請輸入驗證碼";
    }

    if (!isEmpty(error)){
      this.setState({ error: error, btnSend: btnSend });
    } else {
      this.setState({ error: {}, btnSend: btnSend });
      this.props.forgetPassword({phone, code});
    }

  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (isAuthTokenValid) {
      return <Redirect to="/members/change_pwd" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { error, phone, code, btnSend, btnStatus, btnSec, showModalSendCode, showModalBackdrop } = this.state;
    
    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(!isAuthTokenValid) && (
        <div id="page">
          <Navbar showLogin={true} showMenuLine={true} />
          <div className="colorlib" style={{backgroundColor: "#fafafa", borderBottom: "1px solid #CBCBCB"}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h1 style={{color: "#000", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>忘記密碼</h1>
                  <form>
                      <div className="form-group">
                        <input id="phone" name="phone" className="form-control" type="text" style={{border: "1.5px solid #000", margin: "0 auto"}} placeholder="輸入手機號碼" required="required" value={phone} onChange={this.onChange} />
                        {error.phone && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.phone}</span> )} 
                      </div>
                      <button type="button" id="button-send" className="btn-send" style={{top: `${btnSend}px`, backgroundColor: `${btnStatus?"#787878":"#F6490D"}`}} onClick={this.sendCodeLogin} disabled={btnStatus}>{`傳送驗證碼${btnSec===0?"":`(${btnSec})`}`}</button>
                      <div className="form-group" style={{marginTop: "-50px"}}>
                        <label htmlFor="code" style={{color: "#787878", fontWeight: "600", marginTop: "2rem", marginLeft: "3rem"}}>發送驗證碼至手機</label>
                        <input id="code" name="code" type="text" className="form-control" placeholder="輸入驗證碼" style={{border: "1.5px solid #000", margin: "0 auto"}} required="required" value={code} onChange={this.onChange} />
                        {error.code && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.code}</span> )} 
                      </div>
                    
                      <div className="form-group">
                        <input type="button" value="登入" className="btn btn-danger btn-block" onClick={this.onClick} />
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModalSendCode}`} id="myModalSendCode" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={{width: "350px",margin: "250px auto"}}>
                    <div className="modal-content"> 
                        <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                            <h3>驗證碼已發送完成</h3>
                            <p>請到您的手機查看，10分鐘有效</p>
                        </div>
                        <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModalSendCode}>關閉</button>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <Footer />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

ForgetPassword.propTypes = {
  sendCodeLogin: PropTypes.func.isRequired,
  forgetPassword: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  errors: state.errors,
  code: state.auth.sendCodeLoginResult,
  member: state.auth.member
});

export default connect(mapStateToProps, { sendCodeLogin, forgetPassword })(ForgetPassword);